module.exports = __webpack_public_path__ + "media/talk3.44ddd5c7.mp4";